var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"elevation-0",attrs:{"small":"","color":"primary","dark":"","fab":""}},[_c('v-icon',[_vm._v(" mdi-cart-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }